import React from 'react';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { FormOutlined, EyeOutlined } from '@ant-design/icons';
import { Table, Row, Col, Breadcrumb, Typography, Tooltip, Tabs } from 'antd';
import { fieldfilter, capitalize } from '../../redux/actions/customFunction';
import { intialPaginationState, showingPageTotalRange, filter } from '../../common_functions';
const ListSupport = props => {
  const [supportType, setSupportType] = useState([]);
  const [fields, setFields] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [tabData, setTabData] = useState({
    activeTab: !!localStorage.getItem('activeTab') ? localStorage.getItem('activeTab') : 'Record Type',
  });
  const [pagination, setPagination] = useState(intialPaginationState);
  const [sorter, setSorter] = useState(null);
  const [loading, setLoading] = useState(false);
  let filtersitems = {};

  useEffect(() => {
    async function fetchData() {
      localStorage.removeItem('activeTab');
      try {
        setLoading(true);
        let new_choices = [];
        let { data: { meta: { options: { choices = [] } = {} } = {} } = {} } = await props.fetchFieldValues('support_table', {
          fields: ['type'],
        });
        choices.map(function (item, i) {
          !item.value.includes('detail') && new_choices.push(item);
        });
        setSupportType(new_choices);
        //get fields from support table
        let { data: { meta: { options: { choices: choices_fields = [] } = {} } = {} } = {} } = await props.fetchFieldValues(
          'support_table',
          {
            fields: ['fields'],
          }
        );
        setFields(choices_fields);
        filtersitems = {};
        filtersitems['type'] = { _eq: tabData.activeTab.toLowerCase() };
        await getTableData(filtersitems, pagination);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.log('error', error);
      }
    }
    if (props.roleType == 'admin' || !!props.tabs_permissions.settings_support_table.view) {
      fetchData();
    }
  }, []);

  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'id',
      key: 'id',
      width: '10%',
      render: (value, item, index) => {
        return (pagination.current - 1) * pagination.pageSize + index + 1;
      },
    },
    {
      title: 'Field Name',
      dataIndex: 'fields',
      type: 'fields',
      width: '15%',
      render: text => {
        return <span>{fieldfilter(fields, text)}</span>;
      },
    },
    {
      title: 'Name',
      dataIndex: 'name',
      type: 'name',
      width: 150,
      ellipsis: true,
      sorter: true,
      ...filter('name'),
    },
    {
      title: 'Code',
      dataIndex: 'code',
      type: 'code',
      width: 120,
      ellipsis: true,
      sorter: true,
      ...filter('code'),
    },
    {
      title: 'Source',
      dataIndex: 'source',
      type: 'source',
      width: 120,
      ellipsis: true,
      sorter: true,
      ...filter('code'),
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      width: 260,
      ellipsis: true,
      sorter: true,
      ...filter('description'),
    },
    {
      title: 'Actions',
      key: 'action',
      width: 90,
      fixed: 'right',
      render: (text, record) => (
        <span>
          <div className="actionbtngroup">
            <Link to={tabData && '/settings/support-table/' + tabData.activeTab.replaceAll(' ', '-').toLowerCase() + '/' + record.id}>
              <Tooltip
                placement="top"
                title={props.roleType === 'admin' || props?.tabs_permissions?.settings_support_table?.edit ? 'Edit' : 'View'}
              >
                <button className="edit-btn">
                  {props.roleType === 'admin' || props?.tabs_permissions?.settings_support_table?.edit ? <FormOutlined /> : <EyeOutlined />}
                </button>
              </Tooltip>
            </Link>
            {props.deleteRecord(
              props,
              record.id,
              'support_table',
              `${tabData.activeTab}?`,
              tableData,
              setTableData,
              props?.tabs_permissions?.settings_support_table?.delete
            )}
          </div>
        </span>
      ),
    },
  ];

  /***Handle tab active key**/
  const handleTabActiveKey = async e => {
    filtersitems = {};
    setTabData({
      ...tabData,
      activeTab: e,
    });
    filtersitems['type'] = { _eq: e.toLowerCase() };
    try {
      setLoading(true);
      await getTableData(filtersitems, intialPaginationState);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  // get support table data
  const getTableData = async (condition, pagiNation, sorter = null) => {
    let respData = await props.getItems('support_table', {
      fields: ['*'],
      filters: condition,
      sort: !!sorter && sorter.field ? (sorter.order === 'ascend' ? '' : '-') + sorter.field : '-id',
      offset: pagiNation.pageSize * (pagiNation.current - 1),
      limit: pagiNation.pageSize,
      meta: 'filter_count',
    });
    setTableData(respData.data);
    pagiNation.total = respData.meta.filter_count;
    setPagination(pagiNation);
  };
  // Handle table change
  let handleTableChange = async (pagination, filters, sorter) => {
    try {
      filtersitems = {};
      setLoading(true);
      setPagination(pagination);
      setSorter(sorter);
      setLoading(true);
      for (var key in filters) {
        if (filters.hasOwnProperty(key)) {
          var val = filters[key];
          if (!!val) {
            filtersitems[key] = { _icontains: val[0] };
          }
        }
      }
      filtersitems['type'] = { _eq: tabData.activeTab.toLowerCase() };
      let respData = await getTableData(filtersitems, pagination, sorter);
      respData.data && setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  return (
    <Row>
      <Col span={24} className="app-breadcrumb-col">
        <Breadcrumb items={[{ title: "Settings", href: "/settings/support-table" }, { title: "Support Table", href: "/settings/support-table" }, { title: capitalize(tabData?.activeTab) }]} />
      </Col>
      <Col className="white-paper" span={24}>
        <div className="dashboard">
          <Row gutter={24} className="page-header-section" align="middle">
            <Col xs={12}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                View Support Table
              </Typography.Title>
            </Col>
            <Col xs={12} justify="end">
              {props.createButton(
                props.roleType,
                props.tabs_permissions.settings_support_table,
                tabData ? '/settings/support-table/' + tabData.activeTab.replaceAll(' ', '-').toLowerCase() + '/new' : '',
                `Create ${capitalize(tabData.activeTab)}`
              )}
            </Col>
          </Row>
          <hr />
          {supportType && (
            <Tabs defaultActiveKey={tabData.activeTab} onChange={handleTabActiveKey} activeKey={tabData.activeTab} items={supportType.map((key, el) => {
  return {
    label: key.text,
    key: key.text
  };
})} />
          )}
          <div className="artist-listtableData fill-table-width">
            <Table
              scroll={{ x: 'max-content' }}
              tableLayout="fixed"
              columns={columns}
              bordered
              rowKey={record => record.id}
              dataSource={tableData}
              pagination={{ ...pagination, ...showingPageTotalRange }}
              loading={loading}
              onChange={handleTableChange}
            />
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default ListSupport;
